var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-icon",
    fillRule: "nonzero",
    fill: "#8E8E93"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6,0 C5.4746,0 5,0.43555 5,1 L5,2 L0.75,2 C0.338875,2 0,2.338875 0,2.75 L0,5.25 C0,5.661125 0.338875,6 0.75,6 L1.5,6 L1.5,19.25 C1.5,19.661125 1.838875,20 2.25,20 L13.25,20 C13.661125,20 14,19.661125 14,19.25 L14,6 L14.75,6 C15.161125,6 15.5,5.661125 15.5,5.25 L15.5,2.75 C15.5,2.338875 15.161125,2 14.75,2 L10.5,2 L10.5,1 C10.5,0.43555 10.0254,0 9.5,0 L6,0 Z M6,0.5 L9.5,0.5 C9.73047,0.5 10,0.7333975 10,1 L10,2 L5.5,2 L5.5,1 C5.5,0.7334 5.769525,0.5 6,0.5 Z M0.75,2.5 L14.75,2.5 C14.8925775,2.5 15,2.6074225 15,2.75 L15,5.25 C15,5.3925775 14.8925775,5.5 14.75,5.5 L0.75,5.5 C0.6074225,5.5 0.5,5.3925775 0.5,5.25 L0.5,2.75 C0.5,2.6074225 0.6074225,2.5 0.75,2.5 Z M2,6 L13.5,6 L13.5,19.25 C13.5,19.3925775 13.3925775,19.5 13.25,19.5 L2.25,19.5 C2.1074225,19.5 2,19.3925775 2,19.25 L2,6 Z M4.75,8.5 C4.612305,8.5 4.5,8.612305 4.5,8.75 L4.5,16.75 C4.5,16.887695 4.612305,17 4.75,17 C4.887695,17 5,16.887695 5,16.75 L5,8.75 C5,8.612305 4.887695,8.5 4.75,8.5 Z M7.75,8.5 C7.612305,8.5 7.5,8.612305 7.5,8.75 L7.5,16.75 C7.5,16.887695 7.612305,17 7.75,17 C7.887695,17 8,16.887695 8,16.75 L8,8.75 C8,8.612305 7.887695,8.5 7.75,8.5 Z M10.75,8.5 C10.612305,8.5 10.5,8.612305 10.5,8.75 L10.5,16.75 C10.5,16.887695 10.612305,17 10.75,17 C10.887695,17 11,16.887695 11,16.75 L11,8.75 C11,8.612305 10.887695,8.5 10.75,8.5 Z",
    id: "Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.d88872d8c2acf2d716f3f384c3f432ab.svg";
export { ForwardRef as ReactComponent };